import { useRef, useEffect } from 'react';

/**
 * An abstraction on top of `useRef` that keeps track of the latest value. Use the ref returned by this hook to ensure that a change in value does not trigger a re-render.
 * @param value - The latest value.
 * @returns A mutable ref object whose current property is the value passed in to the hook.
 */
function useLatest(value) {
  var valueRef = useRef(value);
  useEffect(function () {
    valueRef.current = value;
  }, [value]);
  return valueRef;
}

export { useLatest as default };
